var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 10.75V14.25C13.3327 17.1667 12.166 18.3333 9.24935 18.3333H5.74935C2.83268 18.3333 1.66602 17.1667 1.66602 14.25V10.75C1.66602 7.83333 2.83268 6.66666 5.74935 6.66666H9.24935C12.166 6.66666 13.3327 7.83333 13.3327 10.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2508 1.66667H10.7508C8.24733 1.66667 7.03919 2.53232 6.74673 4.61575C6.66931 5.16726 7.13077 5.625 7.68769 5.625H9.25078C12.7508 5.625 14.3758 7.25 14.3758 10.75V12.3131C14.3758 12.87 14.8335 13.3315 15.385 13.2541C17.4685 12.9616 18.3341 11.7535 18.3341 9.25001V5.75001C18.3341 2.83334 17.1674 1.66667 14.2508 1.66667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b7c557508f3a4d056b4a1f706a179e4b.svg";
export { ForwardRef as ReactComponent };